/* eslint-disable react/destructuring-assignment */
// eslint-disable-next-line import/no-unresolved
import { useLiveQuery } from 'next-sanity/preview';
import PostPage, { PostPageProps } from './PostPage';
import { Post, postAndMoreStoriesQuery, Settings, settingsQuery } from '../../libs/sanity.queries';

export default function PreviewPostPage(props: PostPageProps) {
  const [{ post: postPreview, morePosts }, loadingPost] = useLiveQuery<{
    post: Post;
    morePosts: Post[];
  }>({ post: props.post, morePosts: props.morePosts }, postAndMoreStoriesQuery, {
    slug: props.post.slug
  });
  const [settings, loadingSettings] = useLiveQuery<Settings>(props.settings, settingsQuery);

  return (
    <PostPage
      preview
      loading={loadingPost || loadingSettings}
      post={postPreview}
      morePosts={morePosts}
      settings={settings}
    />
  );
}
